import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useAccount } from 'wagmi';

import { GenesisSelection } from './GenesisWidget'; 
import { fetchEduPrice } from '../../../services/staking';

import { StakingContext } from '../../../contexts/StakingContext';

import { ReactComponent as QuestionMark } from '../assets/question-mark-circle.svg';

const avgBSCBlockTime = 3; // 3 seconds
const secondsInOneWeek = 7 * 24 * 3600;
const avgBlocksPerWeek = Math.floor(secondsInOneWeek / avgBSCBlockTime); // 201600


export function ActiveStakes() {
    const estRewardTooltip = <Tooltip id='est-reward-tooltip'>Based on average number of blocks per week on Binance Smart Chain</Tooltip>
    
    return <Container>
        <Row className='header-row'>
            <Col lg={6}>Item</Col>
            <Col lg={3}>Boosters</Col>
            <Col lg={3}>Est. Reward per week <OverlayTrigger placement='bottom' delay={{show: 50, hide: 250}} overlay={estRewardTooltip}><QuestionMark /></OverlayTrigger></Col>
            {/* <Col>Unclaimed Reward</Col>
            <Col>Lifetime Reward</Col> */}
        </Row>
        <DataPanel />
    </Container>
}

function DataPanel(props) {
    const { address, status } = useAccount();
    const {fetching, fetched, stakedMapping, stakedPublishers, currEduPrice} = useContext(StakingContext);

    if(status == "connected" && !address) return <p className='notif'>Please connect your wallet to view your active stakes.</p>;

    if(address && fetching) return <p>...</p>

    if(fetched && !stakedPublishers.length) return <p className='notif'>You currently do not have any staked Publisher NFTs</p>

    return stakedPublishers.length > 0 && stakedPublishers
        .map(x => { return {...x, id: x.publisher_nft_id}}) // potentially sort by stake timestamps
        .map(x => (
            <PNFT id={x.id} key={x.id} stakedMapping={stakedMapping} currEduPrice={currEduPrice} {...props} />))
    
}

const edu = new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 });

function PNFT({ id, stakedMapping, currEduPrice }) {
    const { metadata } = useContext(StakingContext)
    const [name, setName] = useState()
    const [nftId, setNftId] = useState()
    const [imgSrc, setImgSrc] = useState()
    const [rarity, setRarity] = useState()
    const [estReward, setEstReward] = useState()

    const [pairInfo, setPairInfo] = useState({ silver: 0, golden: 0})
    const [pairedPoints, setPairedPoints] = useState(0)

    useEffect(() => {
        id = id.toString()
        if(metadata && metadata[id]) {
            const data = metadata[id]
            setName(data?.name)
            setNftId(data?.id)
            setImgSrc(data?.image)
            setRarity(data?.tier.toLowerCase())
            setEstReward(data?.yieldPerBlock * avgBlocksPerWeek)
        }
    }, [metadata, id])

    useEffect(() => {
        id = id + ""
        if(stakedMapping && stakedMapping.get(id)) {
            // there are paired genesis
            setPairInfo({
                golden: stakedMapping.get(id).golden,
                silver: stakedMapping.get(id).silver
            })

            setPairedPoints(stakedMapping.get(id).points)
        }
    }, [stakedMapping, id])

    return <Row>
        <Col lg={6}>
            <div className='pnft-item'>
                <div className='img-wrapper'>
                    <img src={imgSrc} width={60} />
                </div>
                <div>
                    <p className='emph'>{name} #{nftId}</p>
                    <p>{rarity}</p>
                </div>
            </div>
        </Col>
        <Col lg={3}>
            <GenesisSelection className="landing-active-stakes"
                data={pairInfo} readOnly
            />
        </Col> {/** enabled by checkbox */}
        <Col lg={3}>{edu.format(estReward)} EDU <br/>
            ${edu.format(currEduPrice * estReward)} USD
        </Col>
    </Row>
}